import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for the Pullit app.
 *
 * Per frontend.md §15.4:
 *  - Default `staleTime` 30s is appropriate for pack browse.
 *  - Orders are refetched on window focus (per-query override elsewhere).
 *  - No optimistic updates on money-touching mutations (enforced at the
 *    mutation call site, not here).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
